import React, { useEffect } from "react";
import InformationsDemandeur from "../pages/InformationsDemandeur";
import InformationsLocal from "../pages/InformationsLocal";
import InformationsProjet from "../pages/InformationsProjet";
import Validation from "../pages/Validation";

const Verification = ({
  formData,
  setFormData,
  handleChange,
  professional,
  professionals,
  handleSignatureEnd,
  clearSignature,
  sigRef,
  confirmMandantEmail,
  confirmMandataireEmail,
  inputFocus,
  setProfessional,
  setProfessionals,
  proprietaireIndivision,
  setProprietaireIndivision,
  proprietairesIndivision,
  setProprietairesIndivision,
  ville,
  CP,
  signature,
  setSignature,
  tooltip,
  page,
}) => {
  let labels = {};

  useEffect(() => {
    formData.Signature = signature;
    setFormData({ ...formData });
  }, [signature]);

  //** permet de masquer tous les inputs uploads sur la page de vérification */
  document.querySelectorAll(".form-upload").forEach((input) => {
    if (page === 5) {
      input.classList.add("d-none");
      input.removeAttribute("required");
    }
  });

  //** Permet de passer tous les champs en disabled sur la page de vérification */
  document.querySelectorAll("input").forEach((input) => {
    if (page === 5 && input.type !== "button" && input.type !== "submit") {
      input.setAttribute("disabled", true);
    }
  });

  document.querySelectorAll(".form-select").forEach((select) => {
    if (page === 5) {
      select.setAttribute("disabled", true);
    }
  });

  //** Permet de convertir la date au format text(DD MM YYYY) lors de l'envoi du formulaire et de l'impression pdf */
  // document.querySelectorAll("input[type='date']").forEach((input) => {
  //   let date = moment(formData[input.name]).format("DD/MM/YYYY");
  //   input.type = "text";
  //   input.value = date;
  //   formData[input.name] = date;
  // });

  //ne pas afficher le bouton pour vérifier le renouvellement
  document?.querySelector("div.btn-renouvellement")?.classList.add("d-none");

  useEffect(() => {
    document.querySelectorAll(".mandataire-group").forEach((input) => {
      if (formData.MandataireOuiNon === "Non") {
        formData[input.name] = "";
      }
    });

    if (formData.PersonneType === "Une personne physique") {
      formData.MandantRaisSos = "";
      formData.MandantFormeJuridique = "";
      formData.MandantSiret = "";
      formData.MandantQualDemandeur = "";
      delete formData.MandantRaisSos;
      delete formData.MandantFormeJuridique;
      delete formData.MandantSiret;
      delete formData.MandantQualDemandeur;
    }

    if (
      formData.ProAutorisationPrec === "" &&
      formData.nomTiers === "" &&
      formData.prenomTiers === ""
    ) {
      delete formData.ProAutorisationPrec;
      delete formData.nomTiers;
      delete formData.prenomTiers;
    }
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".getLabel");
    elements.forEach((element) => {
      const label = document.querySelector(`label[for="${element.id}"]`);
      if (label) {
        labels[element.name + "_label"] = label.textContent;
        setFormData({ ...formData, labels });
      }
    });
  }, []);

  useEffect(() => {
    const formElements = document.querySelectorAll("form [name]");
    const fieldOrder = Array.from(formElements).map((el) => el.name);
    const sortedFormData = {};
    fieldOrder.forEach((fieldName) => {
      if (formData.hasOwnProperty(fieldName)) {
        sortedFormData[fieldName] = formData[fieldName];
      }
    });
    setFormData((prevFormData) => ({
      ...sortedFormData,
      ...prevFormData,
    }));
  }, []);

  // useEffect(() => {
  //   const formElements = document.querySelectorAll("form [name]");
  //   const fieldOrder = Array.from(formElements).map((el) => el.name);
  //   const sortedFormData = {};
  //   fieldOrder.forEach((fieldName) => {
  //     const label = document.querySelector(`label[for="${fieldName.id}"]`);
  //     if (label && formData.hasOwnProperty(fieldName)) {
  //       sortedFormData[fieldName] = formData[fieldName];
  //     }
  //   });
  //   setFormData((prevFormData) => {
  //     Object.keys(prevFormData).forEach((key) => {
  //       const label = document.querySelector(`label[for="${key}"]`);
  //       if (!label) {
  //         delete prevFormData[key];
  //       }
  //     });
  //     return {
  //       ...sortedFormData,
  //       ...prevFormData,
  //       labels,
  //     };
  //   });
  // }, []);

  return (
    <div id="pdf">
      <div className="page">
        <InformationsDemandeur
          formData={formData}
          setFormData={setFormData}
          handleChange={handleChange}
          confirmMandataireEmail={confirmMandataireEmail}
          confirmMandantEmail={confirmMandantEmail}
          professional={professional}
          setProfessional={setProfessional}
          professionals={professionals}
          setProfessionals={setProfessionals}
          proprietaireIndivision={proprietaireIndivision}
          setProprietaireIndivision={setProprietaireIndivision}
          proprietairesIndivision={proprietairesIndivision}
          setProprietairesIndivision={setProprietairesIndivision}
          ville={ville}
          CP={CP}
        />
      </div>
      <div className="page">
        <InformationsProjet
          formData={formData}
          setFormData={setFormData}
          handleChange={handleChange}
          confirmMandataireEmail={confirmMandataireEmail}
          confirmMandantEmail={confirmMandantEmail}
          professional={professional}
          setProfessional={setProfessional}
          professionals={professionals}
          setProfessionals={setProfessionals}
          proprietaireIndivision={proprietaireIndivision}
          setProprietaireIndivision={setProprietaireIndivision}
          proprietairesIndivision={proprietairesIndivision}
          setProprietairesIndivision={setProprietairesIndivision}
          ville={ville}
          CP={CP}
          page={page}
        />
      </div>
      {(!formData.ProAutorisationPrec ||
        formData.ProAutorisationPrec === "") && (
        <div className="page">
          <InformationsLocal
            formData={formData}
            setFormData={setFormData}
            handleChange={handleChange}
            confirmMandataireEmail={confirmMandataireEmail}
            confirmMandantEmail={confirmMandantEmail}
            inputFocus={inputFocus}
            professional={professional}
            setProfessional={setProfessional}
            professionals={professionals}
            setProfessionals={setProfessionals}
            proprietaireIndivision={proprietaireIndivision}
            setProprietaireIndivision={setProprietaireIndivision}
            proprietairesIndivision={proprietairesIndivision}
            setProprietairesIndivision={setProprietairesIndivision}
            ville={ville}
            CP={CP}
            page={page}
          />
        </div>
      )}
      <div className="page">
        <Validation
          formData={formData}
          setFormData={setFormData}
          handleChange={handleChange}
          confirmMandataireEmail={confirmMandataireEmail}
          confirmMandantEmail={confirmMandantEmail}
          handleSignatureEnd={handleSignatureEnd}
          clearSignature={clearSignature}
          sigRef={sigRef}
          inputFocus={inputFocus}
          professional={professional}
          setProfessional={setProfessional}
          professionals={professionals}
          setProfessionals={setProfessionals}
          proprietaireIndivision={proprietaireIndivision}
          setProprietaireIndivision={setProprietaireIndivision}
          proprietairesIndivision={proprietairesIndivision}
          setProprietairesIndivision={setProprietairesIndivision}
          signature={signature}
          setSignature={setSignature}
          ville={ville}
          CP={CP}
          tooltip={tooltip}
          page={page}
        />
      </div>
    </div>
  );
};

export default Verification;
